
import { get } from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ObjectHelper extends Vue {

    public safeObjProperty(object: object, property: string, defaultValue: any = ''): any {
        return get(object, property, defaultValue);
    }
}
